export const mcn = (...args) => {
    return args.filter(Boolean).join(" ");
};
